import styled from 'styled-components';

export const StyledCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: ${props => (props.horizontal ? 'row' : 'column')}
    ${props => (props.reverse ? '-reverse' : '')};
`;

export const StyledCardHeader = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
`;

export const StyledCardMedia = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: ${props => props.size || '33%'};
  ${props =>
    props.imageSrc
      ? `
    background-image: url(${props.imageSrc});
    background-size: contain;
    background-repeat: no-repeat;
  `
      : ''}
`;

export const StyledCardContent = styled.div`
  flex: 1;
  flex-grow: 1;
  flex-shrink: 1;
`;

export const StyledCardActions = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
`;
